import React, { useEffect, useState } from 'react'
import { HeartPulse } from 'react-bootstrap-icons'
import { useParams } from 'react-router-dom'
import ErrorDialog from '../../../../../../components/dialogs/ErrorDialog'
import Authentication from '../../../../../../libs/api/services/Authentication'
import MessagingServiceProvider from '../../../../../../libs/api/services/MessagingServiceProvider'
import EmailConfigurationComponentCombined from '../../../configuration/facility/components/wizard/Email/EmailConfigurationComponentCombined'
import UserEmailDiscoverComponent from './UserEmailDiscoverComponent'

export default function UserEmailDetails({ title, description, navigation, errors, setValue, values }) {
    const { state } = useParams()

    const [error, setError] = useState()

    const [mode, setMode] = useState('')
    const [serviceProviderService, setServiceProviderService] = useState()
    const [properties, setProperties] = useState([])
    const [status, setStatus] = useState()

    useEffect(() => {
        title('Configuration')
        description('Please enter the account details for this email address')
        if (state) {
            setServiceProviderService({ id: state })
            setMode('Discover')
        }
        _loadSettings()
        // if (Object.keys(values).includes('oauth') && values.oauth === 'recheck')
        //     _handleLookupEmailAccount()
    }, [])

    const _loadSettings = () => {
        // Find service where name = audience | {"audienceType":"SingleUser"} | and user is {"audienceType":"SingleUser","audienceUser":{"id":2044,"title":"","firstName":"Patient","lastName":"Patient","username":"PAT","password":"PAT","emailAddress":"","mobileNumber":"","userRoles":[],"userFacilitieRoles":[]}}
        MessagingServiceProvider
            .FindServiceProviderAccountForUser(Authentication.UserId(), Authentication.getFacility() ? Authentication.getFacility() : -1,)
            .then((r) => {
                setProperties({ mailBoxConfig: JSON.parse(r.property) })
            }).catch((e) => { })

        MessagingServiceProvider
            .FindServiceProviderAccountStatus(Authentication.UserId(), Authentication.getFacility() ? Authentication.getFacility() : -1,)
            .then((r) => {
                setStatus(r)
            }).catch((e) => { })


    }
    const _setProperties = () => {
        MessagingServiceProvider
            .UpdateUserEmailAddcount(Authentication.UserId(), Authentication.getFacility() ? Authentication.getFacility() : -1, properties)
            .then((r) => {
                title('Configuration')
                description('Verifying your email details')
                navigation([])
                setServiceProviderService(r)
                setMode('Discover')
            })
            .catch((e) => { setError(e.message) })
    }

    useEffect(() => {
        if (properties.mailBoxConfig && (
            properties.mailBoxConfig.incomming_type &&
            properties.mailBoxConfig.incomming_domain &&
            properties.mailBoxConfig.incomming_port &&
            properties.mailBoxConfig.outgoing_domain &&
            properties.mailBoxConfig.outgoing_port &&
            properties.mailBoxConfig.emailAddress &&
            properties.mailBoxConfig.password
        ))
            navigation([
                {
                    text: 'Test & Continue', type: 'Action', action: async () => { _setProperties() }
                }
            ])
        else navigation([])
    }, [properties])

    switch (mode) {
        case 'Discover': return (<UserEmailDiscoverComponent service={serviceProviderService} />)
        default:
            return (
                <>
                    <ErrorDialog error={error} humanize={true} onClose={() => setError()} />

                    <div>
                        {status &&
                            <div className='p-2 bg-secondary-container m-2'>
                                <HeartPulse className='me-2' />
                                {status.status && status.status === "CLOSED" ? "Ok" : status.status}
                            </div>
                        }
                        <EmailConfigurationComponentCombined
                            onChange={(r) => Object.keys(r).length > 0 ? setProperties({ ...properties, mailBoxConfig: r }) : undefined}
                            defaultValue={properties && properties.mailBoxConfig ? properties.mailBoxConfig : undefined}
                            type={'both'} />
                    </div>
                </>
            )
    }

}
